var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "294.667px",
    height: "203.333px",
    viewBox: "0 0 294.667 203.333",
    enableBackground: "new 0 0 294.667 203.333",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3B34F",
    d: "M186.389,82.025l12.128,37.1c0.862,2.636,4.108,3.579,6.248,1.812l36.224-29.903 c0,0-38.493-15.015-38.493-14.196C202.496,77.657,186.389,82.025,186.389,82.025z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9DB87",
    d: "M281.963,10.721c-23.656,9.356-100.013,40.646-128.914,52.501c-3.815,1.565-3.587,7.039,0.343,8.292 l32.997,10.511l12.09,36.982c0.486,1.487,1.714,2.446,3.084,2.704c1.112,0.209,2.753-29.949,2.753-29.949 s34.688,25.726,51.142,37.875c4.054,2.992,9.843,0.742,10.803-4.205c4.901-25.261,17.157-88.424,21.347-110.018 C288.237,12.168,285.038,9.505,281.963,10.721z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5C467",
    d: "M201.564,121.711c1.112,0.209,2.752-29.949,2.752-29.949l56.988-53.529 c0.385-0.362-0.075-0.972-0.529-0.701l-74.386,44.493l12.09,36.982C198.966,120.495,200.193,121.454,201.564,121.711z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#D3B34F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: 5,
    d: "M4.108,194.333 c39.142-0.12,91.174-22.192,101.618-64.574c4.215-17.104,0.468-35.43-13.088-47.913c-17.131-15.774-35.94-1.36-31.312,20.657 c7.603,36.168,51.777,62.953,85.352,63.331c19.405,0.219,37.611-9.086,44.586-28.101"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.ed7c2648464dca79592bd167b422ee02.svg";
export { ForwardRef as ReactComponent };